<template>
  <div class="step-interest">
    <h2>How interested are you in astrology?</h2>
    <div class="num-area">
      <div class="num-row">
        <button v-for="n in 11" :key="n-1" class="num-btn" :class="{ active: interest === n-1 }" @click="interest = n-1">{{ n-1 }}</button>
      </div>
      <div class="num-labels"><span>Not at all</span><span>Very much</span></div>
    </div>
    <button class="primary-btn" :disabled="interest === null" @click="$emit('next', interest)">Continue</button>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'StepInterest',
  emits: ['next'],
  setup() {
    const interest = ref(null)
    return { interest }
  }
}
</script>

<style scoped>
.step-interest { max-width: 520px; margin: 0 auto; padding: 20px; display: flex; flex-direction: column; align-items: center; gap: 40px; text-align: center; }
.step-interest h2 { font-size: 24px; font-weight: 700; color: #fff; line-height: 1.3; }
.num-area { width: 100%; display: flex; flex-direction: column; gap: 12px; }
.num-row { display: flex; gap: 6px; justify-content: center; }
.num-btn { width: 40px; height: 40px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.04); color: rgba(255,255,255,0.5); font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.15s; font-family: inherit; }
.num-btn:hover { background: rgba(108,99,255,0.1); }
.num-btn.active { background: #6c5ce7; border-color: #6c5ce7; color: #fff; transform: scale(1.1); }
.num-labels { display: flex; justify-content: space-between; font-size: 12px; color: rgba(255,255,255,0.35); }
.primary-btn { padding: 16px 24px; background: #6c5ce7; border: none; border-radius: 12px; color: #fff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; width: 100%; }
.primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.primary-btn:hover { background: #7c6ff0; box-shadow: 0 6px 20px rgba(108,99,255,0.35); }
</style>
